<template>
	<div class="full-width pa-4 wrapper">
		<!-- <v-card class="pa-5"> -->
		<h5 class="headline mb-5">{{ title }}</h5>
		<v-layout>
			<v-flex xs12 sm6 lg3>
				<v-text-field
					label="Enter Phone"
					v-model="phoneNo"
					@keyup.enter="fetchRetailerDetails"
				></v-text-field>
			</v-flex>
			<v-flex xs12 sm6 lg3>
				<v-btn
					fab
					@click="fetchRetailerDetails"
					small
					:disabled="!phoneNo || phoneNo.length !== 10"
					color="green"
					class="white--text"
					:loading="grabUserLoading"
				>
					<v-icon>search</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>

		<v-layout v-if="userData.userType" class="my-2">
			<v-flex xs12 lg6>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-select
							label="User Role"
							:items="possibleRoles"
							v-model="selectedRole"
							item-text="value"
							item-value="key"
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-select
							label="Shop Type"
							:items="possibleShopType"
							v-model="selectedUserData.shopType"
							item-text="value"
							item-value="key"
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout
					class="verCenteredChild"
					v-if="
						selectedRole === this.executive ||
							selectedRole === this.retailer ||
							selectedRole === this.promoter
					"
				>
					<v-flex xs12 sm6 lg6>
						<v-select
							v-model="selectedUserData.appTypes"
							:items="possibleAppTypes"
							label="App Type*"
							placeholder="App Type*"
							multiple
							chips
							persistent-hint
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-text-field
							label="Shop Name"
							v-model="selectedUserData.shopName"
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-select
							label="Commission Scheme"
							:items="possibleCommissionScheme"
							v-model="selectedUserData.commissionScheme"
							item-text="value"
							item-value="key"
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-select
							label="Game Commission Scheme"
							:items="possibleCommissionScheme"
							v-model="selectedUserData.gameCommissionScheme"
							item-text="value"
							item-value="key"
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-text-field
							label="Retail Commission Rate"
							v-model="selectedUserData.retailCommissionRate"
							:rules="[onlyDigitRule, numberLessThan12]"
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-text-field
							label="Game Commission Rate"
							v-model="selectedUserData.gameRetailCommissionRate"
							:rules="[onlyDigitRule, numberLessThan12]"
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-text-field
							label="Credit Limit"
							v-model="selectedUserData.creditLimit"
							:rules="[onlyDigitRule]"
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-text-field
							label="Tsm Number"
							v-model="selectedUserData.tsmNumber"
							:rules="[validPhoneNoRule, onlyDigitRule]"
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout class="verCenteredChild">
					<v-flex xs12 sm6 lg6>
						<v-select
							label="Status"
							:items="possibleStatus"
							v-model="selectedUserData.status"
							item-text="value"
							item-value="key"
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex xs12 sm6 lg6>
						<v-text-field
							label="Substitute for Above User (optional)"
							v-model="substituteUserPhone"
							:loading="grabUserLoading"
							:rules="[checkRoleMatch]"
						></v-text-field>
					</v-flex>
					<v-flex class="verCenteredChild">
						<v-tooltip right>
							<v-icon
								class="grey--text px-2"
								dark
								slot="activator"
								>info</v-icon
							>
							<span
								>All the mappings of above user, will be mapped
								to this user.</span
							>
						</v-tooltip>
					</v-flex>
				</v-layout>
				<v-layout v-if="substituteUser.userType">
					<v-flex
						xs12
						sm6
						lg6
						class="verCenteredChild substitute-user-info my-2 py-1"
						:class="substituteUserColor"
					>
						<div>NAME: {{ substituteUser.retailerName }}</div>
						<div>ROLE: {{ substituteUserType }}</div>
					</v-flex>
				</v-layout>
				<v-btn
					class="mx-0 mt-4 white--text"
					:color="themeInputColor"
					@click="callUpdateUserRole"
					:disabled="checkDisable"
					:loading="updateUserRoleLoading"
					>Update</v-btn
				>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import {
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	SHOW_ALERT
} from "@/store/action-types";
import * as utils from "@/utils";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import { mapState } from "vuex";

const DEFAULT_RETAIL_COMMISSION_RATE = 7;
const DEFAULT_GAME_COMMISSION_RATE = 9;

export default {
	name: "UpdateMappingTool",
	props: ["title", "themeInputColor"],
	data() {
		const executive = "executive";
		const distributor = "dstr";
		const retailer = "dstrRetail";
		const captain = "captain";
		const promoter = "promoter";
		const tsm = "tsm";
		const rbm = "rbm";
		const shopTypeAgent = "agent";
		return {
			phoneNo: "",
			selectedRole: null,
			substituteUserPhone: "",
			distributor,
			retailer,
			executive,
			captain,
			promoter,
			tsm,
			rbm,
			shopTypeAgent,
			possibleRoles: [
				{
					key: distributor,
					value: "Distributor"
				},
				{
					key: retailer,
					value: "Retailer"
				},
				{
					key: executive,
					value: "Executive"
				},
				{
					key: captain,
					value: "Captain"
				},
				{
					key: promoter,
					value: "Promoter"
				},
				{
					key: tsm,
					value: "TSM"
				},
				{
					key: rbm,
					value: "RBM"
				}
			],
			possibleAppTypes: ["JEET11", "RUMMY"],
			possibleShopType: [
				{ key: shopTypeAgent, value: "Agent" },
				{ key: "agency", value: "Agency" },
				{ key: "agency_moj", value: "Moj Agency" },
				{ key: "inShop", value: "In Shop" },
				{ key: "outShop", value: "Out Shop" },
				{ key: "online", value: "Online" },
				{ key: null, value: "None" }
			],
			possibleCommissionScheme: [
				{ key: "old", value: "Old" },
				{ key: "new", value: "New" }
			],
			possibleStatus: [
				{ key: "ACTIVE", value: "Active" },
				{ key: "INACTIVE", value: "Inactive" }
			],
			grabUserLoading: false,
			updateUserRoleLoading: false,
			userData: {},
			selectedUserData: {
				shopType: null,
				shopName: "",
				commissionScheme: "old",
				gameCommissionScheme: "old",
				gameRetailCommissionRate: DEFAULT_GAME_COMMISSION_RATE,
				retailCommissionRate: DEFAULT_RETAIL_COMMISSION_RATE,
				creditLimit: 0,
				tsmNumber: "",
				status: ""
			},
			substituteUser: {},
			onlyDigitRule: v => utils._onlyDigitsRule(v),
			validPhoneNoRule: v => utils._validPhoneNoRule(v),
			numberLessThan12: v =>
				/^([0-9]|[1][0-2]|12)$/.test(v.replace(/^0+/, "")) ||
				"Enter Number ≤ 12",
			appTypes: null
		};
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		}),
		checkDisable() {
			const isAnyDataChanged = Object.keys(this.selectedUserData).some(
				key =>
					String(
						(key === "tsmNumber" ? "91" : "") +
							this.selectedUserData[key]
					) !== String(this.userData[key])
			);
			return (
				!this.phoneNo ||
				!this.selectedRole ||
				(!!this.substituteUserPhone &&
					this.substituteUser.userType !== this.userData.userType) ||
				(!isAnyDataChanged &&
					this.selectedRole === this.userData.userType)
			);
		},
		substituteUserType() {
			const a = this.possibleRoles.find(
				role => role.key === this.substituteUser.userType
			);
			return a.value;
		},
		substituteUserColor() {
			if (this.userData.userType === this.substituteUser.userType) {
				return "green--text";
			}
			return "error--text";
		},
		checkRoleMatch() {
			if (
				this.substituteUserPhone &&
				this.substituteUserPhone.length === 10 &&
				this.substituteUser.userType &&
				this.substituteUser.userType !== this.userData.userType
			) {
				return "User and substitute User must have same role.";
			} else if (this.substituteUserPhone === this.phoneNo) {
				return "User and substitute user cannot be same!";
			}
			return false;
		}
	},
	methods: {
		fetchRetailerDetails() {
			if (!this.grabUserLoading) {
				this.grabUserLoading = true;
				this.getRetailer(this.phoneNo)
					.then(data => {
						this.userData = {
							...data
						};
					})
					.catch(() => {})
					.then(() => {
						this.grabUserLoading = false;
					});
			}
		},
		getRetailer(phoneNo) {
			return this.$store.dispatch(
				FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch,
				{
					p: Number("91" + phoneNo)
				}
			);
		},
		async callUpdateUserRole() {
			if (this.updateUserRoleLoading) return;
			this.updateUserRoleLoading = true;
			const updateRoleEndpoint = `${BASE_URL}/jeet11-retail/v1.0.0/updateRole`;
			const updateRetailerEndpoint = `${BASE_URL}/jeet11-retail/v1.0.0/updateRetailers`;
			const {
				gameRetailCommissionRate,
				retailCommissionRate,
				creditLimit,
				tsmNumber,
				status,
				appTypes,
				...rest
			} = this.selectedUserData;
			const retailerData = {
				gameRetailCommissionRate: gameRetailCommissionRate
					? Number(gameRetailCommissionRate)
					: null,
				retailCommissionRate: retailCommissionRate
					? Number(retailCommissionRate)
					: null,
				creditLimit: creditLimit ? Number(creditLimit) : null,
				tsmNumber: tsmNumber ? Number("91" + tsmNumber) : null,
				...(status !== (this.userData.status || "ACTIVE")
					? { status }
					: {}),
				appTypes:
					appTypes && appTypes.length > 0
						? JSON.stringify(appTypes)
						: null,
				...rest
			};
			const updateRolePayload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					userPhone: Number("91" + this.phoneNo),
					newRole: this.selectedRole,
					...(this.substituteUserPhone
						? {
								substitutePhone: Number(
									"91" + this.substituteUserPhone
								)
						  }
						: {})
				}
			};
			const updateRetailerPayload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					retailerDetails: [
						{
							userId: this.userData.userId,
							phoneNo: Number(this.userData.phoneNo),
							...retailerData
						}
					]
				}
			};

			try {
				if (this.selectedRole !== this.userData.userType) {
					const { statusCode, errMsg } = await ApiService.post(
						updateRoleEndpoint,
						updateRolePayload
					);
					if (statusCode !== 200) {
						this.showAlert(errMsg || "Something went wrong.");
						this.updateUserRoleLoading = false;
						return;
					}
				}
				const {
					statusCode,
					errMsg,
					response: resp = {}
				} = await ApiService.post(
					updateRetailerEndpoint,
					updateRetailerPayload
				);
				if (statusCode === 200 && resp.status === "success") {
					this.showAlert("User Updated Successfully");
				} else {
					this.showAlert(errMsg || "Something went wrong.");
					this.updateUserRoleLoading = false;
					return;
				}
			} catch (e) {
				this.showAlert("Something went wrong.");

				this.updateUserRoleLoading = false;
				return;
			}

			this.resetForm();
			this.updateUserRoleLoading = false;
		},
		resetForm() {
			this.phoneNo = "";
			this.userData = {};
			this.substituteUserPhone = "";
			this.substituteUser = {};
			this.selectedRole = null;
		},
		showAlert(text) {
			this.$store.dispatch(SHOW_ALERT.dispatch, { text });
		}
	},
	watch: {
		userData(newVal) {
			if (newVal) {
				const {
					userType,
					shopType = null,
					shopName = "",
					commissionScheme = "old",
					gameCommissionScheme = "old",
					gameRetailCommissionRate = DEFAULT_GAME_COMMISSION_RATE,
					retailCommissionRate = DEFAULT_RETAIL_COMMISSION_RATE,
					creditLimit = 0,
					tsmNumber = "",
					status = "ACTIVE",
					appTypes
				} = newVal;
				this.selectedRole = userType;
				this.selectedUserData = {
					shopType,
					shopName,
					commissionScheme,
					gameCommissionScheme,
					gameRetailCommissionRate:
						gameRetailCommissionRate ||
						DEFAULT_GAME_COMMISSION_RATE,
					retailCommissionRate:
						retailCommissionRate || DEFAULT_RETAIL_COMMISSION_RATE,
					creditLimit,
					tsmNumber: String(tsmNumber).slice(2),
					appTypes: appTypes ? JSON.parse(appTypes) : appTypes,
					status: status || "ACTIVE"
				};
			} else {
				this.selectedRole = null;
			}
		},
		substituteUserPhone(newVal) {
			if (newVal && newVal.length === 10) {
				if (newVal === this.phoneNo) {
					this.showAlert("User and Substitute User cannot be same!");
					return;
				}
				this.grabUserLoading = true;
				this.getRetailer(newVal)
					.then(data => {
						this.substituteUser = { ...data };
					})
					.catch(() => {})
					.finally(() => {
						this.grabUserLoading = false;
					});
			} else {
				this.substituteUser = {};
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.user-info {
	width: 100%;
	.field {
		font-size: 16px;
		min-width: 140px;
	}
}
.select-width {
	width: 200px;
	max-width: 200px;
}
.wrapper {
	min-height: 400px;
}
.substitute-user-info {
	flex-direction: column;
	border-radius: 4px;
	border: 1px solid;
}
</style>
